import { render, staticRenderFns } from "./allocateInventoryItems.vue?vue&type=template&id=81e15f86"
import script from "./allocateInventoryItems.ts?vue&type=script&lang=js&external"
export * from "./allocateInventoryItems.ts?vue&type=script&lang=js&external"
import style0 from "./allocateInventoryItems.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports